import { DOUBLE_OUT_MIN_DARTS } from '@/constants/checkoutTable'

class CheckoutService {
    constructor() {
        this.oneDartCheckouts = new Map()
        this.twoDartCheckouts = new Map()
        this.threeDartCheckouts = new Map()

        this.generateCheckouts()
    }

    generateCheckouts() {
        this.oneDartCheckouts.set(2, ['D1'])
        this.oneDartCheckouts.set(4, ['D2'])
        this.oneDartCheckouts.set(6, ['D3'])
        this.oneDartCheckouts.set(8, ['D4'])
        this.oneDartCheckouts.set(10, ['D5'])
        this.oneDartCheckouts.set(12, ['D6'])
        this.oneDartCheckouts.set(14, ['D7'])
        this.oneDartCheckouts.set(16, ['D8'])
        this.oneDartCheckouts.set(18, ['D9'])
        this.oneDartCheckouts.set(20, ['D10'])
        this.oneDartCheckouts.set(22, ['D11'])
        this.oneDartCheckouts.set(24, ['D12'])
        this.oneDartCheckouts.set(26, ['D13'])
        this.oneDartCheckouts.set(28, ['D14'])
        this.oneDartCheckouts.set(30, ['D15'])
        this.oneDartCheckouts.set(32, ['D16'])
        this.oneDartCheckouts.set(34, ['D17'])
        this.oneDartCheckouts.set(36, ['D18'])
        this.oneDartCheckouts.set(38, ['D19'])
        this.oneDartCheckouts.set(40, ['D20'])
        // this.oneDartCheckouts.set(50, ['Bull'])

        this.twoDartCheckouts.set(100, ['T20', 'D20'])
        this.twoDartCheckouts.set(98, ['T20', 'D19'])
        this.twoDartCheckouts.set(97, ['T19', 'D20'])
        this.twoDartCheckouts.set(96, ['T20', 'D18'])
        this.twoDartCheckouts.set(95, ['T19', 'D19'])
        this.twoDartCheckouts.set(94, ['T18', 'D20'])
        this.twoDartCheckouts.set(93, ['T19', 'D18'])
        this.twoDartCheckouts.set(92, ['T20', 'D16'])
        this.twoDartCheckouts.set(91, ['T17', 'D20'])
        this.twoDartCheckouts.set(90, ['T20', 'D15'])
        this.twoDartCheckouts.set(89, ['T19', 'D16'])
        this.twoDartCheckouts.set(88, ['T16', 'D20'])
        this.twoDartCheckouts.set(87, ['T17', 'D18'])
        this.twoDartCheckouts.set(86, ['T18', 'D16'])
        this.twoDartCheckouts.set(85, ['T15', 'D20'])
        this.twoDartCheckouts.set(84, ['T20', 'D12'])
        this.twoDartCheckouts.set(83, ['T17', 'D16'])
        this.twoDartCheckouts.set(82, ['T14', 'D20'])
        this.twoDartCheckouts.set(81, ['T19', 'D12'])
        this.twoDartCheckouts.set(80, ['T20', 'D10'])
        this.twoDartCheckouts.set(79, ['T19', 'D11'])
        this.twoDartCheckouts.set(78, ['T18', 'D12'])
        this.twoDartCheckouts.set(77, ['T19', 'D10'])
        this.twoDartCheckouts.set(76, ['T20', 'D8'])
        this.twoDartCheckouts.set(75, ['T17', 'D12'])
        this.twoDartCheckouts.set(74, ['T14', 'D16'])
        this.twoDartCheckouts.set(73, ['T19', 'D8'])
        this.twoDartCheckouts.set(72, ['T16', 'D12'])
        this.twoDartCheckouts.set(71, ['T13', 'D16'])
        this.twoDartCheckouts.set(70, ['T10', 'D20'])
        this.twoDartCheckouts.set(69, ['T15', 'D12'])
        this.twoDartCheckouts.set(68, ['T20', 'D4'])
        this.twoDartCheckouts.set(67, ['T17', 'D8'])
        this.twoDartCheckouts.set(66, ['T10', 'D18'])
        this.twoDartCheckouts.set(65, ['T19', 'D4'])
        this.twoDartCheckouts.set(64, ['T16', 'D8'])
        this.twoDartCheckouts.set(63, ['T13', 'D12'])
        this.twoDartCheckouts.set(62, ['T10', 'D16'])
        this.twoDartCheckouts.set(61, ['T15', 'D8'])
        this.twoDartCheckouts.set(60, ['20', 'D20'])
        this.twoDartCheckouts.set(59, ['19', 'D20'])
        this.twoDartCheckouts.set(58, ['18', 'D20'])
        this.twoDartCheckouts.set(57, ['17', 'D20'])
        this.twoDartCheckouts.set(56, ['16', 'D20'])
        this.twoDartCheckouts.set(55, ['15', 'D20'])
        this.twoDartCheckouts.set(54, ['14', 'D20'])
        this.twoDartCheckouts.set(53, ['13', 'D20'])
        this.twoDartCheckouts.set(52, ['12', 'D20'])
        this.twoDartCheckouts.set(51, ['11', 'D20'])
        this.twoDartCheckouts.set(50, ['18', 'D16'])
        this.twoDartCheckouts.set(49, ['9', 'D20'])
        this.twoDartCheckouts.set(48, ['8', 'D20'])
        this.twoDartCheckouts.set(47, ['7', 'D20'])
        this.twoDartCheckouts.set(46, ['6', 'D20'])
        this.twoDartCheckouts.set(45, ['5', 'D20'])
        this.twoDartCheckouts.set(44, ['4', 'D20'])
        this.twoDartCheckouts.set(43, ['3', 'D20'])
        this.twoDartCheckouts.set(42, ['10', 'D16'])
        this.twoDartCheckouts.set(41, ['9', 'D16'])

        this.threeDartCheckouts.set(170, ['T20', 'T20', 'Bull'])
        this.threeDartCheckouts.set(167, ['T20', 'T19', 'Bull'])
        this.threeDartCheckouts.set(164, ['T20', 'T18', 'Bull'])
        this.threeDartCheckouts.set(161, ['T20', 'T17', 'Bull'])
        this.threeDartCheckouts.set(160, ['T20', 'T20', 'D20'])
        this.threeDartCheckouts.set(158, ['T20', 'T20', 'D19'])
        this.threeDartCheckouts.set(157, ['T20', 'T19', 'D20'])
        this.threeDartCheckouts.set(156, ['T20', 'T20', 'D18'])
        this.threeDartCheckouts.set(155, ['T20', 'T19', 'D19'])
        this.threeDartCheckouts.set(154, ['T20', 'T18', 'D20'])
        this.threeDartCheckouts.set(153, ['T20', 'T19', 'D18'])
        this.threeDartCheckouts.set(152, ['T20', 'T20', 'D16'])
        this.threeDartCheckouts.set(151, ['T20', 'T17', 'D20'])
        this.threeDartCheckouts.set(150, ['T20', 'T18', 'D18'])
        this.threeDartCheckouts.set(149, ['T20', 'T19', 'D16'])
        this.threeDartCheckouts.set(148, ['T20', 'T16', 'D20'])
        this.threeDartCheckouts.set(147, ['T20', 'T17', 'D18'])
        this.threeDartCheckouts.set(146, ['T20', 'T18', 'D16'])
        this.threeDartCheckouts.set(145, ['T20', 'T15', 'D20'])
        this.threeDartCheckouts.set(144, ['T20', 'T20', 'D12'])
        this.threeDartCheckouts.set(143, ['T20', 'T17', 'D16'])
        this.threeDartCheckouts.set(142, ['T20', 'T14', 'D20'])
        this.threeDartCheckouts.set(141, ['T20', 'T19', 'D12'])
        this.threeDartCheckouts.set(140, ['T20', 'T16', 'D16'])
        this.threeDartCheckouts.set(139, ['T19', 'T14', 'D20'])
        this.threeDartCheckouts.set(138, ['T20', 'T18', 'D12'])
        this.threeDartCheckouts.set(137, ['T19', 'T16', 'D16'])
        this.threeDartCheckouts.set(136, ['T20', 'T20', 'D8'])
        this.threeDartCheckouts.set(135, ['T20', 'T17', 'D12'])
        this.threeDartCheckouts.set(134, ['T20', 'T14', 'D16'])
        this.threeDartCheckouts.set(133, ['T20', 'T19', 'D8'])
        this.threeDartCheckouts.set(132, ['T20', 'T16', 'D12'])
        this.threeDartCheckouts.set(131, ['T20', 'T13', 'D16'])
        this.threeDartCheckouts.set(130, ['T20', 'T20', 'D5'])
        this.threeDartCheckouts.set(129, ['T19', 'T16', 'D12'])
        this.threeDartCheckouts.set(128, ['T18', 'T14', 'D16'])
        this.threeDartCheckouts.set(127, ['T20', 'T17', 'D8'])
        this.threeDartCheckouts.set(126, ['T19', 'T19', 'D6'])
        this.threeDartCheckouts.set(125, ['25', 'T20', 'D20'])
        this.threeDartCheckouts.set(124, ['T20', 'T16', 'D8'])
        this.threeDartCheckouts.set(123, ['T19', 'T16', 'D9'])
        this.threeDartCheckouts.set(122, ['T18', 'T20', 'D4'])
        this.threeDartCheckouts.set(121, ['T17', 'T10', 'D20'])
        this.threeDartCheckouts.set(120, ['T20', '20', 'D20'])
        this.threeDartCheckouts.set(119, ['T19', 'T10', 'D16'])
        this.threeDartCheckouts.set(118, ['T20', '18', 'D20'])
        this.threeDartCheckouts.set(117, ['T20', '17', 'D20'])
        this.threeDartCheckouts.set(116, ['T20', '16', 'D20'])
        this.threeDartCheckouts.set(115, ['T20', '15', 'D20'])
        this.threeDartCheckouts.set(114, ['T20', '14', 'D20'])
        this.threeDartCheckouts.set(113, ['T20', '13', 'D20'])
        this.threeDartCheckouts.set(112, ['T20', '12', 'D20'])
        this.threeDartCheckouts.set(111, ['T20', '19', 'D16'])
        this.threeDartCheckouts.set(110, ['T20', '18', 'D16'])
        this.threeDartCheckouts.set(109, ['T19', '20', 'D16'])
        this.threeDartCheckouts.set(108, ['T20', '16', 'D16'])
        this.threeDartCheckouts.set(107, ['T19', '18', 'D16'])
        this.threeDartCheckouts.set(106, ['T20', '14', 'D16'])
        this.threeDartCheckouts.set(105, ['T19', '16', 'D16'])
        this.threeDartCheckouts.set(104, ['T18', '18', 'D16'])
        this.threeDartCheckouts.set(103, ['T20', '3', 'D20'])
        this.threeDartCheckouts.set(102, ['T20', '10', 'D16'])
        this.threeDartCheckouts.set(101, ['T20', '1', 'D20'])
        this.threeDartCheckouts.set(99, ['T19', '10', 'D16'])
    }

    getCheckoutOptions(remainingScore) {
        // Check for 1-dart checkout first (most efficient)
        if (this.oneDartCheckouts.has(remainingScore)) {
            const checkout = this.oneDartCheckouts.get(remainingScore)
            return {
                type: 'one_dart',
                darts: checkout,
                message: `${checkout[0]} = ${remainingScore}`,
            }
        }

        // Check for 2-dart checkout
        if (this.twoDartCheckouts.has(remainingScore)) {
            const checkout = this.twoDartCheckouts.get(remainingScore)
            return {
                type: 'two_dart',
                darts: checkout,
                message: `${checkout.join(' + ')} = ${remainingScore}`,
            }
        }

        // Check for 3-dart checkout
        if (this.threeDartCheckouts.has(remainingScore)) {
            const checkout = this.threeDartCheckouts.get(remainingScore)
            return {
                type: 'three_dart',
                darts: checkout,
                message: `${checkout.join(' + ')} = ${remainingScore}`,
            }
        }

        // No checkout found
        return { type: 'no_checkout', message: 'Check checkout chart' }
    }

    getCheckoutMessage(remainingScore) {
        const checkout = this.getCheckoutOptions(remainingScore)
        return checkout.type === 'no_checkout' ? null : checkout.message
    }

    hasCheckout(remainingScore) {
        return (
            this.oneDartCheckouts.has(remainingScore) ||
            this.twoDartCheckouts.has(remainingScore) ||
            this.threeDartCheckouts.has(remainingScore)
        )
    }

    isValidCheckout(remainingScore) {
        return this.hasCheckout(remainingScore) && remainingScore > 0
    }

    canFinishWithTriple(remainingScore) {
        if (remainingScore <= 0) return false

        if (remainingScore === 60) return true
        if (remainingScore === 57) return true
        if (remainingScore === 54) return true
        if (remainingScore === 51) return true
        if (remainingScore === 48) return true
        if (remainingScore === 45) return true
        if (remainingScore === 42) return true
        if (remainingScore === 39) return true
        if (remainingScore === 36) return true
        if (remainingScore === 33) return true
        if (remainingScore === 30) return true
        if (remainingScore === 27) return true
        if (remainingScore === 24) return true
        if (remainingScore === 21) return true
        if (remainingScore === 18) return true
        if (remainingScore === 15) return true
        if (remainingScore === 12) return true
        if (remainingScore === 9) return true
        if (remainingScore === 6) return true
        if (remainingScore === 3) return true

        return false
    }

    hasMasterCheckout(remainingScore) {
        return this.hasCheckout(remainingScore) || this.canFinishWithTriple(remainingScore)
    }

    getPossibleDartCounts(score) {
        const possibleCounts = []
        const minDarts = DOUBLE_OUT_MIN_DARTS[score]

        if (minDarts === null || minDarts === undefined) {
            return []
        }

        for (let i = minDarts; i <= 3; i++) {
            possibleCounts.push(i)
        }

        return possibleCounts
    }
}

export default new CheckoutService()
